import React from 'react';
import { useIntl } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import Tag, { TagColors, TagSizes } from '@/components/switchback/Tag/Tag';
import { ICategory } from '@/services/types/blog/post.types';

interface ICategoryCrumbs {
  categories: ICategory[];
}

const CategoryCrumbs: React.FC<ICategoryCrumbs> = ({ categories }) => {
  const intl = useIntl();

  return (
    <div className="flex py-4 mr-4 flex-nowrap md:flex-wrap gap-y-3 gap-x-2">
      <Link legacy href="/blog">
        <a href="/blog" className="whitespace-nowrap">
          <Tag color={TagColors.primary} size={TagSizes.small}>
            {intl.formatMessage({ defaultMessage: 'Blog', id: 'tv5FG3' })}
          </Tag>
        </a>
      </Link>
      {categories.map(c => {
        const categoryLink = c?.link.split('/category/')[1];
        return (
          <Link legacy href={`/blog/category/${categoryLink}`} key={c.id}>
            <a href={`/blog/category/${categoryLink}`} className="whitespace-nowrap" title={c.name}>
              <Tag color={TagColors.primary} size={TagSizes.small}>
                <span dangerouslySetInnerHTML={{ __html: c.name }} />
              </Tag>
            </a>
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryCrumbs;
